enum EventsTags {
  Draft = 'Draft',
  Published = 'Published',
  Live = 'Live',
}

export default EventsTags;
